import { AuthContext } from '@repo-level/core-front';
import { LootboxStage } from 'api/common';
import { RealTimeServiceContext } from 'contexts/realTimeService';
import { EXTRA_SPIN_LOOTBOX_TITLES } from 'modules/wheel/components/helpers';
import { useContext, useMemo } from 'react';

export const useLuckyWheel = () => {
  const { isAuthenticated } = useContext(AuthContext);
  const { lootboxes } = useContext(RealTimeServiceContext);

  const lootbox = useMemo(() => {
    if (!isAuthenticated) return null;
    return lootboxes.find(({ stage }) => stage === LootboxStage.Issued) || null;
  }, [lootboxes, isAuthenticated]);

  const isExtraLootbox = useMemo(() => {
    if (!lootbox) return false;
    return EXTRA_SPIN_LOOTBOX_TITLES.includes(lootbox.title);
  }, [lootbox]);

  return { lootbox, isExtraLootbox };
};
